<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-20">
            <md-card style="margin-bottom: 0.375rem !important;">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <div class="card-icon">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'calendar']" />
                            </div>
                            <h4 class="title">Date</h4>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-65">
                            <div class="md-multiselect">
                                <label>Date de début</label>
                                <multiselect
                                    v-model="filter.startMonth"
                                    :options="months"
                                    :preserve-search="true"
                                    :option-height="104"
                                    label="label"
                                    track-by="number"
                                    placeholder="Mois"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-35">
                            <div class="md-multiselect">
                                <multiselect
                                    v-model="filter.startYear"
                                    :options="years"
                                    :preserve-search="true"
                                    :option-height="104"
                                    placeholder="Année"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-65">
                            <div class="md-multiselect">
                                <label>Date de fin</label>
                                <multiselect
                                    v-model="filter.endMonth"
                                    :options="months"
                                    :preserve-search="true"
                                    :option-height="104"
                                    label="label"
                                    track-by="number"
                                    placeholder="Mois"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-35">
                            <div class="md-multiselect">
                                <multiselect
                                    v-model="filter.endYear"
                                    :options="years"
                                    :preserve-search="true"
                                    :option-height="104"
                                    placeholder="Année"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mt-2">
                        <md-button class="md-default md-icon-button md-raised my-auto" @click="resetToCurrentMonth">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'calendar']" />
                            <span class="leading-none ml-2 font-medium">Mois actuel</span>
                        </md-button>
                    </div>
                </md-card-content>
                <md-card-actions v-if="dateError">
                    <div class="block-alert danger">
                        <p class="font-medium">L'amplitude de date choisie est trop large (12 mois maximum avec un filtre supplémentaire, ou 4 mois sans filtre)</p>
                    </div>
                </md-card-actions>
            </md-card>
        </div>
        <div class="md-layout-item md-size-80">
            <md-card style="margin-bottom: 0.375rem !important;">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <div class="card-icon">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'filter']" />
                            </div>
                            <h4 class="title">Filtres</h4>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-35">
                            <div class="md-multiselect md-multiselect-multiple">
                                <label>Secteurs</label>
                                <multiselect
                                    v-model="filter.sectors"
                                    :options="sectors"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :option-height="104"
                                    label="name"
                                    track-by="id"
                                    placeholder="Secteur(s)"
                                    selectLabel="" selectedLabel="Sélectionné" deselectLabel="Retirer"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-65">
                            <div class="md-multiselect md-multiselect-multiple">
                                <label>Clients</label>
                                <multiselect
                                    v-model="filter.clients"
                                    :options="clients"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :option-height="104"
                                    label="name"
                                    track-by="id"
                                    placeholder="Client(s)"
                                    selectLabel="" selectedLabel="Sélectionné" deselectLabel="Retirer"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-70">
                            <div class="md-multiselect md-multiselect-multiple">
                                <label>Sites</label>
                                <multiselect
                                    v-model="filter.sites"
                                    :options="sites"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :option-height="104"
                                    label="name"
                                    track-by="id"
                                    placeholder="Site(s)"
                                    selectLabel="" selectedLabel="Sélectionné" deselectLabel="Retirer"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-30">
                            <div class="md-multiselect">
                                <label>Technicien</label>
                                <multiselect
                                    v-model="filter.technician"
                                    :options="technicians"
                                    label="full_name"
                                    track-by="id"
                                    placeholder="Technicien"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout md-alignment-center-space-between">
                        <div class="md-layout-item md-size-20">
                            <md-checkbox class="mt-1.5 mb-0" v-model="filter.is_baiting_unpermanent">Appatage non permanent</md-checkbox>
                        </div>
                        <div class="md-layout-item md-size-25">
                            <div class="flex items-center justify-end">
                                <div class="mr-2">
                                    <md-button class="md-success md-icon-button md-raised my-auto" @click="filterData">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'filter']" />
                                        <span class="leading-none ml-2 font-medium">Filtrer</span>
                                    </md-button>
                                </div>
                                <div>
                                    <md-button class="md-default md-icon-button md-raised my-auto" @click="resetFilters">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'times-circle']" />
                                        <span class="leading-none ml-2 font-medium">Réinitialiser</span>
                                    </md-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
            <div class="flex items-center justify-between">
                <div class="flex items-center space-x-9">
                    <div class="badge-button">Interventions du mois</div>
                    <div class="badge-button bg-info">{{ monthStats.plannedCount }} prévues ({{monthStats.plannedHours}} h)</div>
                    <div class="badge-button bg-success">{{ monthStats.interventionsCount }} planifiées ({{monthStats.interventionsHours}} h)</div>
                </div>
                <div class="flex items-center justify-end space-x-9">
                    <div class="badge-button">Reste à planifier</div>
                    <div class="badge-button bg-warning">{{ monthStats.plannedCount - monthStats.interventionsCount }} en attente ({{monthStats.plannedHours - monthStats.interventionsHours }} h)</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ManagementFilter",
    props: {
        technicians: Array
    },
    data() {
        return {
            years: [],
            months: this.$moment.months().map((month, key) => {return {number: key, label: month.charAt(0).toUpperCase() + month.slice(1)}}),
            filter: {},
            sectors: [],
            clients: [],
            sites: [],
            monthStats: [],
            dateError: false
        }
    },
    methods: {
        formatYearFilter() {
            for(let i = -5; i <= 4; i++) {
                this.years.push((this.$moment().year() + i))
            }
        },
        async getOptions() {
            const { data: sectors } = await this.$store.dispatch('sectors/getSectors')
            this.sectors = sectors
            const { data: clients } = await this.$store.dispatch('clients/fetchAllClients')
            this.clients = clients
            const { data: sites } = await this.$store.dispatch('sites/fetchAllSites')
            this.sites = sites
        },
        async getMonthStats() {
            let monthStats = await this.$store.dispatch('planningManagement/getMonthStats')
            this.monthStats = monthStats.data
        },
        resetToCurrentMonth() {
            this.filter.startMonth = this.months[this.$moment().month()]
            this.filter.startYear = this.$moment().year()
            this.filter.endMonth = this.months[this.$moment().month()]
            this.filter.endYear = this.$moment().year()
            this.setLocalStorage()
            this.emitData()
        },
        resetFilters() {
            this.filter.sectors = []
            this.filter.clients = []
            this.filter.sites = []
            this.filter.technician = null
            this.filter.is_baiting_unpermanent = false
            this.setLocalStorage()
            this.emitData()
        },
        filterData() {
            this.setLocalStorage()
            this.emitData()
        },
        setLocalStorage() {
            localStorage.setItem('management-filter', JSON.stringify(this.filter))
        },
        emitData() {
            const startDate = this.$moment().month(this.filter.startMonth.number).year(this.filter.startYear)
            const endDate = this.$moment().month(this.filter.endMonth.number).year(this.filter.endYear)
            const difference = endDate.diff(startDate, "months")
            if (difference >= 0 && (difference < 4 || (difference < 12 && (this.filter.sectors.length || this.filter.clients.length || this.filter.sites.length || this.filter.technician !== null)))) {
                this.$emit('filter-data', this.filter);
                this.dateError = false
            } else {
                this.dateError = true
            }
        }
    },
    async mounted() {
        await this.getOptions()
        await this.getMonthStats()
        this.formatYearFilter()
        let routeParamsCount = Object.keys(this.$route.query).length
        if (routeParamsCount !== 0) {
            const client = this.clients.find((client) => client.id === parseInt(this.$route.query.clientId))
            const site = this.sites.find((site) => site.id === parseInt(this.$route.query.siteId))

            let filter = {
                startMonth: this.months[this.$moment().month()],
                endMonth: this.months[this.$moment().month()],
                startYear: this.$moment().year(),
                endYear: this.$moment().year(),
                sectors: [],
                clients: client ? [client] : [],
                sites: site ? [site] : [],
                technician: null,
                is_baiting_unpermanent: false,
            }
            if (this.$route.query.year) {
                filter.startYear = this.$route.query.year
                filter.endYear = this.$route.query.year
                filter.startMonth = this.months[0]
                if (routeParamsCount === 1) {
                    filter.endMonth = this.months[3]
                } else {
                    filter.endMonth = this.months[11]
                }
            }

            this.filter = filter
        } else {
            this.filter = localStorage.getItem('management-filter') !== null ? JSON.parse(localStorage.getItem('management-filter')) : {
                startMonth: this.months[this.$moment().month()],
                endMonth: this.months[this.$moment().month()],
                startYear: this.$moment().year(),
                endYear: this.$moment().year(),
                sectors: [],
                clients: [],
                sites: [],
                technician: null,
                is_baiting_unpermanent: false,
            }
        }
        this.emitData()
    }
}
</script>

<style scoped lang="scss">
.md-layout.md-gutter {
    margin: 0;
    .md-layout-item {
        padding: 0 10px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
}

.badge-button {
    position: relative;
    margin: 0.3125rem 1px;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: top;
    overflow: hidden;
    outline: none;

    height: auto;
    width: auto;
    min-height: 27px !important;
    min-width: 235px !important;

    font-size: 12px;
    font-weight: 500;
    line-height: 1.42857;
    font-family: inherit;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 0;

    background: $gray-color;
    color: #ffffff;

    border: none;
    border-radius: 3px;

    white-space: nowrap;
    z-index: 5;
    will-change: box-shadow, transform;
    -webkit-appearance: button;

    &.bg-success {
        background: $brand-success;
    }
    &.bg-info {
        background: $brand-info;
    }
    &.bg-warning {
        background: $brand-warning;
    }
}
</style>
